enum InsightType {
  TASK = 'task',
  EPIC = 'epic',
  INITIATIVE = 'initiative',
  PULL_REQUEST = 'pull_request',
}

enum InsightSeverity {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

enum InsightStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

type RiskInsight = {
  id: string;
  organization: string;
  insight_type: InsightType;
  message: string;
  recommendation_action: string;
  is_active: boolean;
  is_dismissed: boolean;
  status: InsightStatus;
  severity: InsightSeverity;
  priority: number;
  risk_category: string;
  affected_item_count: number;
  affected_item_ids: string[];
  statistical_data: {
    total_count: number;
    average_risk_score: number;
    high_risk_count: number;
    medium_risk_count: number;
    low_risk_count: number;
    high_risk_percentage: number;
  };
  pattern_hash: string;
  metadata_created_at: string;
  metadata_updated_at: string;
};

type RiskInsightList = Omit<RiskInsight, 'affected_item_ids' | 'statistical_data' | 'pattern_hash' | 'organization'>;

type RiskInsightUpdate = {
  status?: InsightStatus;
  is_dismissed?: boolean;
};

type AffectedItem = {
  id: string;
  code?: string;
  name: string;
  url?: string;
  type?: string;
  raw_type?: string | null;
  raw_type_label?: string | null;
  status?: string;
  state?: string;
  created_at?: string;
  estimate?: number;
  start_date?: string;
  end_date?: string;
  project_name?: string;
  assignee_name?: string;
  epic_name?: string;
  repository_name?: string;
  author_name?: string;
  risk_score?: number;
};

type AffectedItemsResponse = {
  insight_id: string;
  insight_type: InsightType;
  affected_items: AffectedItem[];
  total_count: number;
};

type InsightFilters = {
  insight_type?: InsightType;
  insight_types?: InsightType[];
  severity?: InsightSeverity;
  status?: InsightStatus;
  is_active?: boolean;
  is_dismissed?: boolean;
};

export { InsightSeverity, InsightStatus, InsightType };
export type { AffectedItemsResponse, InsightFilters, RiskInsight, RiskInsightList, RiskInsightUpdate };
